<template>
  <div>
    <div class="myBill"
         id="myBill">
      <div class="bullTop">
        <section class="loan-lists">
          <el-form ref="form" class="repo-notice-list__search" :inline="true" :model="search" label-width="90px">
            <el-form-item label="审核状态" label-width="70">
              <el-select v-model="approveListValue"
                        placeholder="请选择"
                        @change="selectapprove">
                <el-option v-for="item in approveList"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="凭证号码" label-width="70">
              <el-input v-model="search.bizNo"></el-input>
            </el-form-item>

            <!-- <el-form-item label="凭证状态" label-width="70">
              <el-select v-model="stateListValue"
                        placeholder="请选择"
                        @change="selectstate"
                        class="stateList">
                <el-option v-for="item in stateList"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"></el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item >
                <el-button type="primary" style="margin-left: 0px"
                        @click="billData()"
                        class="btnAdd">查询</el-button>
                <el-button type="primary" style="margin-left: 0px"
                        @click="bounced()"
                        class="btnAdd">添加</el-button>

                <el-button type="primary" style="margin-left: 0px"
                        @click="importData()"
                        class="btnAdd">批量导入(EXCEL)</el-button>           

                <el-button type="primary" style="margin-left: 0px"
                        @click="importData('ocr')"
                        class="btnAdd">批量导入(OCR)</el-button>                
            </el-form-item>
          </el-form>

          <!--<el-tabs @tab-click="handleClick" v-model="activeName" >-->
          <!--<el-tab-pane v-for="item in labelName" :label="item.label" 
                :name="item.state"-->
          <!--:key="item.name"></el-tab-pane>-->
          <!--</el-tabs>-->

          <router-view></router-view>
        </section>
        <!--<ul class="bullState" id="bullState">-->
        <!--<li v-for="(item,index) in labelName" :key="index" @click="handleClick(item,index)" class="bullLi">{{item.label}}</li>-->
        <!--</ul>-->
        <!--添加-->
        <!-- <el-button
          size="mini"
          @click="bounced()" class="btn btnAdd">添加
        </el-button>-->
        <div class="btnPost">
        </div>
      </div>
<!-- 批量导入Excel -->
 <el-dialog title="批量导入(EXCEL)" :visible.sync="dialogImportVisibleExcel" :modal-append-to-body="false" :close-on-click-modal="false" class="dialog-import">
    <div :class="{'import-content': importFlag === 1, 'hide-dialog': importFlag !== 1}">
        <el-upload class="upload-demo"
          :action="importUrl"
          :name ="name"
          :limit="1"
          :data="excelData"
          :headers="importHeaders"
          :on-preview="handlePreview"
          :on-remove="handleRemove"
          :before-upload="beforeUploadImportExcel"
          :on-error="uploadFailImport"
          :on-success="uploadSuccessImport"
          :file-list="fileList"
          :with-credentials="withCredentials">
           <el-button size="small" type="primary" :disabled="processing">{{uploadTip}}</el-button>
           <el-button size="small" type="primary" @click="downTemplate" round>下载模板</el-button>
           <div slot="tip" class="el-upload__tip">只能上传excel文件</div>
        </el-upload>
        </div>
 </el-dialog>
 <!-- 批量导入Ocr -->
 <el-dialog title="增值税发票批量导入(OCR自动识别)" :visible.sync="dialogImportVisibleOcr" :modal-append-to-body="false" :close-on-click-modal="false" class="dialog-import" >
    <div :class="{'import-content': importFlag === 1, 'hide-dialog': importFlag !== 1}" class="financing-dialog" style="height: 150px;">
          <el-form :model="ruleForm"
                   :rules="rulesImport"
                   ref="ruleFormImport"
                   label-width="100px"
                   class="demo-ruleForm financing-dialog-form-body">
            <!-- <el-form-item label="买方"
                          prop="buyerId">
              <el-select v-model="ruleForm.buyerId"
                         placeholder="请选择买方"
                         class="buyerName">
                <el-option :label="item.buyerName"
                           :value="item.buyerId"
                           v-for="(item,index) in ruleForm.buyerNameList"
                           :key="index"></el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item label="合同编号"
                          prop="contractNumber">
              <el-input v-model="ruleForm.contractNumber"
                        placeholder="请输入合同名称及合同编号"></el-input>
            </el-form-item>
<!--              <el-form-item label="应收账款净额"
                          prop="netAmount">
              <el-input v-model="ruleForm.netAmount"
                        placeholder="请输入应收账款净额"></el-input>
            </el-form-item> -->
             <el-form-item label="产品名称"
                          prop="baseProductId">
               <el-select v-model="ruleForm.baseProductId" placeholder="请选择产品">
                <el-option
                  v-for="item in productList"
                  :key="item.productId"
                  :label="item.productName"
                  :value="item.productId">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="签署日期"
                          prop="signDate">
              <el-date-picker type="date" @change="dateChange($event,'signDate')"
                              placeholder="签署日期"
                              v-model="ruleForm.signDate"
                              value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
            <el-form-item class="el-form-item2">            
            <el-upload class="upload-demo"
                :action="importUrl"
                :headers="importHeaders"
                :limit="1"
                :data="ocrData"
                :on-preview="handlePreview"
                :on-remove="handleRemove"
                :before-upload="beforeUploadImportOcr"
                :on-error="uploadFailImport"
                :on-success="uploadSuccessImportOcr"
                :file-list="fileList"
                :with-credentials="withCredentials">
                 <el-button size="small" type="primary" :disabled="processing">{{uploadTip}}</el-button>
                 <div slot="tip" class="el-upload__tip">请上传zip压缩文件（<span style="color:red">请将png\jpg\jpeg格式的发票图片打包上传</span>）</div>
              </el-upload>
            </el-form-item>
          </el-form>      
        </div>
          <div slot="footer"
              class="dialog__footer" style="margin-top: 3.5rem;">
            <span slot="footer" class="dialog-footer">
              <el-button  @click="importOcr">开始导入</el-button>
            </span>
          </div>     
 </el-dialog>      
      <!--列表数据-->
      <el-table :data="voucherInfoList"
                style="width: 100%"
                align="center">
        <el-table-column label="序号"
                         width="70"
                         align="center">
          <template slot-scope="scope">{{scope.$index+1}}</template>
        </el-table-column>
         <el-table-column show-overflow-tooltip
                         prop="type"
                         label="类型"
                         align="center"></el-table-column>
        <el-table-column show-overflow-tooltip
                         prop="buyerName"
                         label="买方"
                         align="center"></el-table-column>
        <el-table-column show-overflow-tooltip
                         prop="bizNo"
                         label="凭证号码"
                         align="center"></el-table-column>
        <el-table-column show-overflow-tooltip
                         label="凭证金额"
                         align="center">
            <template slot-scope="scope">
              <span style="color:#EB662B;">¥{{scope.row.receivableAmount | addThousandSign(2)}}</span>
            </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip
                         prop="authStateName"
                         label="审核状态"
                         width="100"
                         align="center"></el-table-column>
        <el-table-column show-overflow-tooltip
                         prop="state"
                         width="100"
                         label="凭证状态"
                         align="center"></el-table-column>
        <el-table-column label="操作"
        width="150"
                         align="center">
          <template slot-scope="scope">
            <el-button size="mini"
                       :type="scope.row.canEdit ? 'primary':''"
                       @click="handleEdit(scope.$index, scope.row)"
                       :class="['btn','operation', (scope.row.canEdit) ?'':'btn-disable']"
                       :disabled="(!scope.row.canEdit)">修改</el-button>
            <el-button size="mini"
                       @click="rowClick(scope.$index, scope.row)"
                       class="btn operation">查看</el-button>
            <el-button size="mini"
                       :type="(scope.row.canDelete) ?'danger':''"
                       @click="removeData(scope.row)"
                       :class="['btn','operation', scope.row.canDelete ?'':'btn-disable']"
                       :disabled="(!scope.row.canDelete)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination v-if="voucherInfoList.length > 0"
                     class="step3_pagination"
                     :page-size="pageSize"
                     :total="voucherInfoCount"
                     :current-page="pageCurrent"
                     @current-change="changePage"
                     layout="prev, pager, next"></el-pagination>
      <!--弹框-->
      <el-dialog :visible.sync="DialogInputBankInfo"
                 :close-on-click-modal="false"
                 top="5%"
                 class="financing-dialog">

        <div class="financing-dialog-form">
          <el-form :model="ruleForm"
                   :rules="rules9"
                   ref="ruleForm9"
                   label-width="125px"
                   class="demo-ruleForm financing-dialog-form-body">
            <el-form-item label="融资产品名称"
                          prop="baseProductId">
              <el-select v-model="ruleForm.baseProductId" placeholder="请选择融资产品">
                <el-option
                  v-for="item in productList"
                  :key="item.productId"
                  :label="item.productName"
                  :value="item.productId">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label=""></el-form-item>                   
            <el-form-item label="贸易合同买方"
                          prop="buyerId">
              <el-select v-model="ruleForm.buyerId"
                         placeholder="请选择贸易合同买方"
                         class="buyerName">
                <el-option :label="item.buyerName"
                           :value="item.buyerId"
                           v-for="(item,index) in ruleForm.buyerNameList"
                           :key="index"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-bind:label="'贸易合同\n名称及编号'"
                          prop="contractNumber" style="white-space: pre-line;">
              <el-input v-model="ruleForm.contractNumber"
                        placeholder="请输入贸易合同名称及编号"></el-input>
            </el-form-item>            
          </el-form>

          <el-form :model="ruleForm"
                   :rules="rules"
                   ref="ruleForm"
                   label-width="125px"
                   class="demo-ruleForm financing-dialog-form-body">
            <el-form-item label="凭证类型"
                          prop="type">
              <el-select v-model="ruleForm.type"
                         placeholder="请选择凭证类型"
                         :disabled="voucherInfoId>0" 
                         :onchange="changeFrom()">
                <el-option :label="item.label"
                           :value="item.value"
                           v-for="(item,index) in typeList"
                           :key="index"></el-option>
              </el-select> 
             </el-form-item>
          </el-form>      
           <el-form :model="ruleForm"
                    
                   :rules="rules2"
                   ref="ruleForm2"
                   label-width="125px"
                   class="demo-ruleForm financing-dialog-form-body">
             <!-- 发票 -->
            <template v-if="!dome">
              <el-form-item label="凭证日期"
                          prop="startTime">
              <el-date-picker type="date" @change="dateChange($event,'startTime')"
                              placeholder="凭证日期"
                              v-model="ruleForm.startTime"
                              value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
            <el-form-item label="凭证号码"
                          prop="lnvoiceNumber">
              <el-input v-model="ruleForm.lnvoiceNumber"
                        placeholder="请输入凭证号码"></el-input>
            </el-form-item>
            <el-form-item label="凭证金额"
                          prop="contractAmount">
              <el-input v-model="ruleForm.contractAmount"
                        placeholder="请输入凭证金额"></el-input>
            </el-form-item>            
            <el-form-item label="订单号">
              <el-input v-model="ruleForm.ddh"
                        placeholder="请输入订单号"></el-input>
            </el-form-item>
            <el-form-item label="送货单号">
              <el-input v-model="ruleForm.receiptNo"
                        placeholder="请输入送货单号"></el-input>
            </el-form-item>
            <el-form-item label="品名">
              <el-input v-model="ruleForm.goodsName"
                        placeholder="请输入品名"></el-input>
            </el-form-item>
            <el-form-item label="规格型号">
              <el-input v-model="ruleForm.spec"
                        placeholder="请输入规格型号"></el-input>
            </el-form-item>
            <el-form-item label="数量">
              <el-input v-model="ruleForm.num"
                        placeholder="请输入数量"></el-input>
            </el-form-item>
            <el-form-item label="计量单位">
              <el-input v-model="ruleForm.unit"
                        placeholder="请输入计量单位"></el-input>
            </el-form-item>
            <el-form-item label="单价">
              <el-input v-model="ruleForm.unitPrice"
                        placeholder="请输入单价"></el-input>
            </el-form-item>
            <el-form-item label="总价"
                          prop="totalPrice">
              <el-input v-model="ruleForm.totalPrice"
                        placeholder="请输入总价"></el-input>
            </el-form-item>
            <el-form-item label="应收账款净额"
                          prop="netAmount">
              <el-input v-model="ruleForm.netAmount"
                        placeholder="应收账款净额"></el-input>
            </el-form-item> 
            <el-form-item label="签署日期"
                          prop="signDate">
              <el-date-picker type="date" @change="dateChange($event,'signDate')"
                              placeholder="签署日期"
                              v-model="ruleForm.signDate"
                              value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
            </template>
          </el-form>
          <el-form :model="ruleForm"
                   :rules="rules3"
                   ref="ruleForm3"
                   label-width="125px"
                   class="demo-ruleForm financing-dialog-form-body">
             <!-- 订单 -->
            <template v-if="dome1"> 
            <el-form-item label="订单日期"
                          prop="djTime">
              <el-date-picker type="date" @change="dateChange($event,'djTime')"
                              placeholder="订单日期"
                              v-model="ruleForm.djTime"
                              value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
            <el-form-item label="订单号"
                          prop="deliveryNo">
              <el-input v-model="ruleForm.deliveryNo"
                        placeholder="请输入订单号"></el-input>
            </el-form-item>
           <el-form-item label="订单总值"
                          prop="ddnum">
              <el-input v-model="ruleForm.ddnum"
                        placeholder="请输入订单总值"></el-input>
            </el-form-item>            
            <el-form-item label="品名"
                          prop="pm">
              <el-input v-model="ruleForm.pm"
                        placeholder="请输入品名"></el-input>
            </el-form-item>
            <el-form-item label="规格型号"
                          prop="ggxh">
              <el-input v-model="ruleForm.ggxh"
                        placeholder="请输入规格型号"></el-input>
            </el-form-item>
            <el-form-item label="单价"
                          prop="dj">
              <el-input v-model="ruleForm.dj"
                        placeholder="请输入单价"></el-input>
            </el-form-item>            
            <el-form-item label="计量单位"
                          prop="dw">
              <el-input v-model="ruleForm.dw"
                        placeholder="请输入计量单位"></el-input>
            </el-form-item>
            <el-form-item label="数量"
                          prop="sl">
              <el-input v-model="ruleForm.sl"
                        placeholder="请输入数量"></el-input>
            </el-form-item>
            <el-form-item label="货物总值"
                          prop="zj">
              <el-input v-model="ruleForm.zj"
                        placeholder="请输入货物总值"></el-input>
            </el-form-item>
            <el-form-item label="应收账款净额"
                          prop="netAmount">
              <el-input v-model="ruleForm.netAmount"
                        placeholder="应收账款净额"></el-input>
            </el-form-item>   
            <el-form-item label=""></el-form-item>
            </template>
          
          </el-form>
          <el-form :model="ruleForm"
                   :rules="rules4"
                   ref="ruleForm4"
                   label-width="125px"
                   class="demo-ruleForm financing-dialog-form-body">
            <!-- 送货单/入库单送货单/入库单 -->
            <template v-if="dome2">
            <el-form-item label="单据日期"
                          prop="djTime2">
              <el-date-picker type="date" @change="dateChange($event,'djTime2')"
                              placeholder="单据日期"
                              v-model="ruleForm.djTime2"
                              value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
            <el-form-item label="单据号码"
                          prop="shrk">
              <el-input v-model="ruleForm.shrk"
                        placeholder="请输入单据号码"></el-input>
            </el-form-item>
            <el-form-item label="单据总值"
                          prop="shnum">
              <el-input v-model="ruleForm.shnum"
                        placeholder="请输入单据总值"></el-input>
            </el-form-item>
            <el-form-item label="应收账款净额"
                          prop="netAmount">
              <el-input v-model="ruleForm.netAmount"
                        placeholder="应收账款净额"></el-input>
            </el-form-item> 
            <el-form-item label=""></el-form-item>
          </template>
            
          
          </el-form>
          <el-form :model="ruleForm"
                   :rules="rules5"
                   ref="ruleForm5"
                   label-width="125px"
                   class="demo-ruleForm financing-dialog-form-body">
            <!-- 结算单 -->
            <template v-if="dome3">
            <el-form-item label="单据日期"
                          prop="djTime3">
              <el-date-picker type="date" @change="dateChange($event,'djTime3')"
                              placeholder="单据日期"
                              v-model="ruleForm.djTime3"
                              value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
            <el-form-item label="单据号码"
                  prop="jsnum">
              <el-input v-model="ruleForm.jsnum"
                        placeholder="请输入单据号码"></el-input>
            </el-form-item>
            <el-form-item label="结算单总金额"
                          prop="jsdnum">
              <el-input v-model="ruleForm.jsdnum"
                        placeholder="请输入结算单总金额"></el-input>
            </el-form-item>
            <el-form-item label="应收账款净额"
                          prop="netAmount">
              <el-input v-model="ruleForm.netAmount"
                        placeholder="应收账款净额"></el-input>
            </el-form-item> 
            <el-form-item label=""></el-form-item>
          </template>
          </el-form>
          <el-form :model="ruleForm"
                   :rules="rules6"
                   ref="ruleForm6"
                   label-width="125px"
                   class="demo-ruleForm financing-dialog-form-body">
             <!-- 银承 -->
            <template v-if="dome5">
           <el-form-item label="票据号码"
                          prop="pjnum">
              <el-input v-model="ruleForm.pjnum"
                        placeholder="请输入票据号码"></el-input>
            </el-form-item>              
            <el-form-item label="出票日期"
                          prop="cpTime">
              <el-date-picker type="date" @change="dateChange($event,'cpTime')"
                              placeholder="出票日期"
                              v-model="ruleForm.cpTime"
                              value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
            <el-form-item label="汇票到期日"
                          prop="receivableEndTime">
              <el-date-picker type="date" @change="dateChange($event,'receivableEndTime')"
                              placeholder="汇票到期日"
                              v-model="ruleForm.receivableEndTime"
                              value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
            <el-form-item label="出票人全称"
                          prop="cprqc">
              <el-input v-model="ruleForm.cprqc"
                        placeholder="请输入出票人全称"></el-input>
            </el-form-item>
            <el-form-item label="承兑人全称"
                          prop="cdrname">
              <el-input v-model="ruleForm.cdrname"
                        placeholder="请输入承兑人全称"></el-input>
            </el-form-item>
            <el-form-item v-bind:label="'承兑人开户行\n行号'"
                          prop="acceptorBankSwift" style="white-space: pre-line;">
              <el-input v-model="ruleForm.acceptorBankSwift"
                        placeholder="请输入承兑人开户行行号"></el-input>
            </el-form-item>            
            <el-form-item v-bind:label="'承兑人开户行\n名称'"
                          prop="cdrkname" style="white-space: pre-line;">
              <el-input v-model="ruleForm.cdrkname"
                        placeholder="请输入承兑人开户行名称"></el-input>
            </el-form-item>
            <el-form-item label="票据金额"
                          prop="pmnum">
              <el-input v-model="ruleForm.pmnum"
                        placeholder="请输入票据金额"></el-input>
            </el-form-item>
              <el-form-item label="应收账款净额"
                            prop="netAmount">
                <el-input v-model="ruleForm.netAmount"
                          placeholder="应收账款净额"></el-input>
              </el-form-item> 
            </template>
          </el-form>
          <el-form :model="ruleForm"
                   :rules="rules7"
                   ref="ruleForm7"
                   label-width="125px"
                   class="demo-ruleForm financing-dialog-form-body">
            <!-- 商承 -->
            <template v-if="dome6">
           <el-form-item label="票据号码"
                          prop="pjnum2">
              <el-input v-model="ruleForm.pjnum2"
                        placeholder="请输入票据号码"></el-input>
            </el-form-item>              
            <el-form-item label="出票日期"
                          prop="cpTime2">
              <el-date-picker type="date" @change="dateChange($event,'cpTime2')"
                              placeholder="出票日期"
                              v-model="ruleForm.cpTime2"
                              value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
            <el-form-item label="汇票到期日"
                          prop="receivableEndTime2">
              <el-date-picker type="date" @change="dateChange($event,'receivableEndTime2')"
                              placeholder="汇票到期日"
                              v-model="ruleForm.receivableEndTime2"
                              value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
            <el-form-item label="出票人全称"
                          prop="cprqc2">
              <el-input v-model="ruleForm.cprqc2"
                        placeholder="请输入出票人全称"></el-input>
            </el-form-item>
            <el-form-item label="承兑人全称"
                          prop="cdrname2">
              <el-input v-model="ruleForm.cdrname2"
                        placeholder="请输入承兑人全称"></el-input>
            </el-form-item>
            <el-form-item v-bind:label="'承兑人开户行\n行号'"
                          prop="acceptorBankSwift2" style="white-space: pre-line;">
              <el-input v-model="ruleForm.acceptorBankSwift2"
                        placeholder="请输入承兑人开户行行号"></el-input>
            </el-form-item>            
            <el-form-item v-bind:label="'承兑人开户行\n名称'"
                          prop="cdrkname2" style="white-space: pre-line;">
              <el-input v-model="ruleForm.cdrkname2"
                        placeholder="请输入承兑人开户行"></el-input>
            </el-form-item>
            <el-form-item label="票据金额"
                          prop="pmnum2">
              <el-input v-model="ruleForm.pmnum2"
                        placeholder="请输入票据金额"></el-input>
            </el-form-item>
              <el-form-item label="应收账款净额"
                            prop="netAmount">
                <el-input v-model="ruleForm.netAmount"
                          placeholder="应收账款净额"></el-input>
              </el-form-item> 
            </template>
          </el-form>
          <el-form :model="ruleForm"
                   :rules="rules8"
                   ref="ruleForm8"
                   label-width="125px"
                   class="demo-ruleForm financing-dialog-form-body">
             <!-- 其他凭证 -->
            <template v-if="dome7">
              <el-form-item label="应收账款净额"
                            prop="netAmount">
                <el-input v-model="ruleForm.netAmount"
                          placeholder="应收账款净额"></el-input>
              </el-form-item>               
            </template>
          </el-form>
          <div style="margin-bottom: 2rem;margin-left: 2.5rem;">
            <span style="color:red;font-size: smaller;"> 温馨提示：</br>请将上述凭证的原件扫描图片或原件照片点击下方“+”号上传</span>
          </div>          
          <ul class="file-list__item-list">
            <template v-for="file in sysFileIds">
              <li v-if="/\.pdf|\.doc|\.rar|\.zip|\.7z/g.test(file.fileName)"
                  :class="['file-list__item-preview', `file-list__
                    ${file.fileName.substr(file.fileName.lastIndexOf('.')+1)}-preview`]"
                                      @click.self="showPreviewImage(file.fileId, false)">
                <div class="file-list__item-delete"
                     @click="deleteUploadedFile(file.fileId)">
                  <i class="el-icon-close"></i>
                </div>
                <div class="file-list__file-name">{{file.fileName}}</div>
              </li>
              <li v-else
                  class="file-list__item-preview">
                <img :src="`${ajaxBaseUrl}/mobile/crmCustomerAttachInfoController/getFile.ht?fileId=${file.fileId}&tokenId=${tokenId}`"
                     @click="showPreviewImage(file.fileId, true)">
                <div class="file-list__item-delete"
                     @click.stop="deleteUploadedFile(file)">
                  <i class="el-icon-close"></i>
                </div>
              </li>
            </template>
            <!--element-ui上传控件不支持IE9，使用webuploader插件替代 @mousedown="changeFileType(file.filesId)"-->
            <li  class="file-list__select-file picker"
                v-show=" sysFileIds.length < 5">
              <i class="el-icon-plus"></i>
            </li>
          </ul>
        </div>
        <span slot="footer"
              class="dialog-footer pinker">
          <el-button type="primary"
                     @click="submitForm()"
                     class="submit">提交</el-button>
        </span>
      </el-dialog>
      

      <el-dialog class="file-preview-modal"
                 title="图片预览"
                 :visible="filePreview.show"
                 :before-close="hidePreviewImage"
                 :close-on-click-modal="false">
        <div class="file-preview-modal__body">
          <img :src="filePreview.src"
               alt="图片预览">
        </div>
        <div slot="footer"
             class="dialog__footer">
          <button class="dialog__footer__confirm-btn"
                  @click="hidePreviewImage">确定</button>
        </div>
      </el-dialog>

      <el-dialog class="progressDialog"
                 title=" "
                 :visible.sync="isShowProgress"
                 size="tiny"
                 top="20%"
                 :show-close="false">
        <el-progress class="upload_progress"
                     :text-inside="true"
                     :stroke-width="18"
                     :percentage="progress"></el-progress>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import * as types from '../../vuex/types';
import 'webuploader/css/webuploader.css';
import api from '../../api/myBill.js';
import productsApi from '../../api/products.js';
import Webuploader from 'webuploader';
import 'webuploader/css/webuploader.css';
import { Loading } from 'element-ui';

export default {
  name: 'MyBill',
  data () {
    return {
      search: {
        bizNo:''
      },
      importUrl: '',
      importHeaders: {
        enctype: 'multipart/form-data'
      },
      ocrData: {},
      excelData: {},
      dialogImportVisibleExcel: false,
      dialogImportVisibleOcr: false,
        name: 'file',
        fileList: [],
        withCredentials: true,
        processing: false,
        uploadTip: '点击上传',
        importFlag: 1,
      dome: false,
      dome1: false,
      dome2: false,
      dome3: false,
      dome5: false,
      dome6: false,
      dome7: false,
      approveListValue: '全部',
      stateListValue: '全部',
      isSubmit: false, // 是否提交
      isValidate: false, // 是否验证买方
      approveList: [
        {
          label: '全部',
          value: ''
        }
      ],
      stateList: [
        {
          label: '全部',
          value: ''
        }
      ],
      typeList: [], // 凭证类型字典列表
      productList: [], // 产品列表
      progress: 0,
      isShowProgress: false,
      filePreview: {
        show: false,
        src: ''
      },
      tokenId: localStorage.getItem('dl_tokenId_bl'),
      sysFileIds: [],
      DialogInputBankInfo: false,
      authState: '',
      state: '',
      voucherInfoCount: 0, // 列表返回总数
      pageSize: 8,
      pageCurrent: 1,
      labelName: [
        {
          label: ' 全部',
          name: '5',
          state: '5'
        },
        {
          label: '未审批',
          name: '0',
          state: '0'
        },
        {
          label: '审批通过',
          name: '1',
          state: '1'
        },
        {
          label: '审批不通过',
          name: '2',
          state: '2'
        }
      ],
      activeName: '5',
      isStretch: true,

      isMasking: false, // 控制蒙版显示
      // state: ['全部', '未审核票据', '已审核票据', '已转让票据'],
      voucherInfoList: [], // 列表数据
      ruleForm: {
        netAmount: '', // 应收账款净额
        baseProductId: '', // 应收账款净额
        buyerId: '', // 买方（核心企业）名称
        type: '', // 凭证类型（默认为发票）
        buyerNameList: [],
        // order: { // 订单

        // },
        contractNumber: '', // 合同编号
        lnvoiceNumber: '', // 发票号码
        deliveryNo: '', // 订单号
        receiptNo: '', // 送货单号
        goodsName: '', // 品名
        spec: '', // 规格型号
        num: '', // 单位
        unit: '', // 数量
        unitPrice: '', // 单价
        totalPrice: '', // 总价
        contractAmount: '', // 发票金额
        drawer: '', // 出票人全称
        acceptor: '', // 承兑人全称
        acceptorBank: '', // 承兑人开户行名称
        // bill: { // 承兑汇票

        // },
        // receivableAmount: '', // 应收账款金额
        // advanceChargeAmount: '', // 预付款金额
        // alreadyPaidAmount: '', // 已付款金额
        // commissionAmount: '', // 佣金及转让金额
        receivableEndTime: '', // 汇票到期日
        receivableEndTime2: '', // 汇票到期日
        // receivableStartTime: '',
        startTime: '', // 开票日期
        djTime: '', // 订单中的单据日期
        htbh: '', // 订单中的合同编号
        ddh: '', // 订单中的订单号
        pm: '', // 订单中的品名
        ggxh: '', // 订单中的规格型号
        dw: '', // 订单中的单位
        sl: '', // 订单中的数量
        dj: '', // 订单中的单价
        zj: '', // 订单中的总价
        ddnum: '', // 订单总额
        djTime2: '', // 送货单/入库单的单据日期
        htbh2: '', // 送货单/入库单的合同编号
        pm2: '', // 送货单/入库单的品名
        shrk: '', // 送货/入库单号
        dd: '', // 送货单/入库单的订单号
        ggxh2: '', // 送货单/入库单的规格型号
        dw2: '', // 送货单/入库单的单位
        sl2: '', // 送货单/入库单的数量
        dj2: '', // 送货单/入库单的单价
        zj2: '', // 送货单/入库单的总价
        shnum: '', // 送货单/入库单的送货单金额
        djTime3: '', // 结算单的单据日期
        htbh3: '', // 结算单的合同编号
        pm3: '', // 结算单的品名
        jsnum: '', // 结算单号
        orderNo: '', // 结算单的收货单号
        ggxh3: '', // 结算单的规格型号
        dw3: '', // 结算单的单位
        sl3: '', // 结算单的数量
        dj3: '', // 结算单的单价
        zj3: '', // 结算单的总价
        jsdnum: '', // 结算单金额
        cpTime: '', // 银承的出票日期
        pjnum: '', // 银承的票据号码
        cprqc: '', // 银承的出票人全称
        cdrname: '', // 银承的承兑人全称
        cdrkname: '', // 银承的承兑人开户行
        pmnum: '', // 银承的票面金额
        cpTime2: '', // 银承的出票日期
        pjnum2: '', // 银承的票据号码
        cprqc2: '', // 银承的出票人全称
        cdrname2: '', // 银承的承兑人全称
        cdrkname2: '', // 银承的承兑人开户行
        pmnum2: '', // 银承的票面金额
        acceptorBankSwift:'',
        acceptorBankSwift2:'',
        signDate:'' // 签署日期
      },
      rules: {
        buyerId: [{ type: 'number',
          required: true,
          message: '请选择买方',
          trigger: 'blur' }],
        type: [{ type: 'string',
          required: true,
          message: '请选择类型',
          trigger: 'change' }],
        baseProductId: [{
          type: 'number',
          required: true,
          message: '请选择产品',
          trigger: 'blur'
        }]
      },

      rules2: {
        buyerId: [{ type: 'number',
          required: true,
          message: '请选择买方',
          trigger: 'blur' }],
        type: [{ type: 'string',
          required: true,
          message: '请选择类型',
          trigger: 'change' }],
        baseProductId: [{
          type: 'number',
          required: true,
          message: '请选择产品',
          trigger: 'blur'
        }],
        contractNumber: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请输入合同名称及合同编号'));
              } else {
                callback();
              }
            }
          }
        ],
        lnvoiceNumber: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请输入发票号码'));
              } else {
                callback();
              }
            }
          }
        ],
        contractAmount: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请输入发票金额'));
              } else if (_.isNaN(Number(value))) {
                callback(new Error('发票金额必须为数字'));
              } else if (Number(value) < 0) {
                callback(new Error('发票金额不能小于0!'));
              } else {
                callback();
              }
            }
          }
        ],
        startTime: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请选择开票日期'));
              } else {
                callback();
              }
            }
          }
        ]

      },
      rules3: {
        buyerId: [{ type: 'number',
          required: true,
          message: '请选择买方',
          trigger: 'blur' }],
        type: [{ type: 'string',
          required: true,
          message: '请选择类型',
          trigger: 'change' }],
        baseProductId: [{
          type: 'number',
          required: true,
          message: '请选择产品',
          trigger: 'blur'
        }],
        htbh: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请输入合同名称及合同编号'));
              } else {
                callback();
              }
            }
          }
        ],
        ddnum: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请输入订单总额'));
              } else if (_.isNaN(Number(value))) {
                callback(new Error('订单总额必须为数字'));
              } else {
                callback();
              }
            }
          }
        ],
        pm: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请输入品名'));
              } else {
                callback();
              }
            }
          }
        ],
        ggxh: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请输入规格型号'));
              } else {
                callback();
              }
            }
          }
        ],
        dw: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请输入单位'));
              } else {
                callback();
              }
            }
          }
        ],
        sl: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请输入数量'));
              } else if (_.isNaN(Number(value))) {
                callback(new Error('数量必须为数字'));
              } else {
                callback();
              }
            }
          }
        ],
        dj: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请输入单价'));
              } else if (_.isNaN(Number(value))) {
                callback(new Error('单价必须为数字'));
              } else {
                callback();
              }
            }
          }
        ],
        zj: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请输入总价'));
              } else if (_.isNaN(Number(value))) {
                callback(new Error('总价必须为数字'));
              } else if (Number(this.ruleForm.sl) * Number(this.ruleForm.dj) != Number(value)) {
                callback(new Error('总价不等于数量*单价之和'));
              } else {
                callback();
              }
            }
          }
        ],
        deliveryNo: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请输入订单号'));
              } else {
                callback();
              }
            }
          }
        ],
        djTime: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请选择单据日期'));
              } else if (
                new Date(value) >= new Date(this.ruleForm.receivableEndTime)
              ) {
                callback(new Error('开始时间不能大于等于结束时间'));
              } else {
                callback();
              }
            }
          }
        ]

      },
      rules4: {
        buyerId: [{ type: 'number',
          required: true,
          message: '请选择买方',
          trigger: 'blur' }],
        type: [{ type: 'string',
          required: true,
          message: '请选择类型',
          trigger: 'change' }],
        baseProductId: [{
          type: 'number',
          required: true,
          message: '请选择产品',
          trigger: 'blur'
        }],
        htbh2: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请输入合同名称及合同编号'));
              } else {
                callback();
              }
            }
          }
        ],
        shrk: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请输入送货/入库单号'));
              } else {
                callback();
              }
            }
          }
        ],

        shnum: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请输入送货单金额'));
              } else if (_.isNaN(Number(value))) {
                callback(new Error('送货单金额必须为数字'));
              } else {
                callback();
              }
            }
          }
        ],

        pm2: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请输入品名'));
              } else {
                callback();
              }
            }
          }
        ],
        ggxh2: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请输入规格型号'));
              } else {
                callback();
              }
            }
          }
        ],
        dw2: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请输入单位'));
              } else {
                callback();
              }
            }
          }
        ],
        sl2: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请输入数量'));
              } else if (_.isNaN(Number(value))) {
                callback(new Error('数量必须为数字'));
              } else {
                callback();
              }
            }
          }
        ],
        dj2: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请输入单价'));
              } else if (_.isNaN(Number(value))) {
                callback(new Error('单价必须为数字'));
              } else {
                callback();
              }
            }
          }
        ],
        zj2: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请输入总价'));
              } else if (_.isNaN(Number(value))) {
                callback(new Error('总价必须为数字'));
              } else if (Number(this.ruleForm.sl2) * Number(this.ruleForm.dj2) != Number(value)) {
                callback(new Error('总价不等于数量*单价之和'));
              } else {
                callback();
              }
            }
          }
        ],
        djTime2: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请选择单据日期'));
              } else if (
                new Date(value) >= new Date(this.ruleForm.receivableEndTime)
              ) {
                callback(new Error('开始时间不能大于等于结束时间'));
              } else {
                callback();
              }
            }
          }
        ]

      },
      rules5: {
        buyerId: [{ type: 'number',
          required: true,
          message: '请选择买方',
          trigger: 'blur' }],
        type: [{ type: 'string',
          required: true,
          message: '请选择类型',
          trigger: 'change' }],
        baseProductId: [{
          type: 'number',
          required: true,
          message: '请选择产品',
          trigger: 'blur'
        }],
        htbh3: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请输入合同名称及合同编号'));
              } else {
                callback();
              }
            }
          }
        ],
        pm3: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请输入品名'));
              } else {
                callback();
              }
            }
          }
        ],
        ggxh3: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请输入规格型号'));
              } else {
                callback();
              }
            }
          }
        ],
        dw3: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请输入单位'));
              } else {
                callback();
              }
            }
          }
        ],
        sl3: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请输入数量'));
              } else if (_.isNaN(Number(value))) {
                callback(new Error('数量必须为数字'));
              } else {
                callback();
              }
            }
          }
        ],
        dj3: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请输入单价'));
              } else if (_.isNaN(Number(value))) {
                callback(new Error('单价必须为数字'));
              } else {
                callback();
              }
            }
          }
        ],
        zj3: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请输入总价'));
              } else if (_.isNaN(Number(value))) {
                callback(new Error('总价必须为数字'));
              } else if (Number(this.ruleForm.sl3) * Number(this.ruleForm.dj3) != Number(value)) {
                callback(new Error('总价不等于数量*单价之和'));
              } else {
                callback();
              }
            }
          }
        ],
        orderNo: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请输入收货单号单号'));
              } else {
                callback();
              }
            }
          }
        ],
        jsnum: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请输入结算单号单号'));
              } else {
                callback();
              }
            }
          }
        ],
        jsdnum: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请输入结算单金额'));
              } else if (_.isNaN(Number(value))) {
                callback(new Error('结算单金额必须为数字'));
              } else {
                callback();
              }
            }
          }
        ],
        djTime3: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请选择单据日期'));
              } else if (
                new Date(value) >= new Date(this.ruleForm.receivableEndTime)
              ) {
                callback(new Error('开始时间不能大于等于结束时间'));
              } else {
                callback();
              }
            }
          }
        ]

      },
      rules6: {
        buyerId: [{ type: 'number',
          required: true,
          message: '请选择买方',
          trigger: 'blur' }],
        type: [{ type: 'string',
          required: true,
          message: '请选择类型',
          trigger: 'change' }],
        baseProductId: [{
          type: 'number',
          required: true,
          message: '请选择产品',
          trigger: 'blur'
        }],
        pmnum: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请输入票面金额'));
              } else if (_.isNaN(Number(value))) {
                callback(new Error('票面金额必须为数字'));
              } else {
                callback();
              }
            }
          }
        ],
        cdrkname: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请输入承兑人开户行'));
              } else {
                callback();
              }
            }
          }
        ],
        acceptorBankSwift: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请输入承兑人开户行行号'));
              } else {
                callback();
              }
            }
          }
        ],
        cprqc: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请输入出票人全称'));
              } else {
                callback();
              }
            }
          }
        ],
        cdrname: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请输入承兑人全称'));
              } else {
                callback();
              }
            }
          }
        ],

        pjnum: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请输入票据号码'));
              } else {
                callback();
              }
            }
          }
        ],
        cpTime: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请选择出票日期'));
              } else if (
                new Date(value) >= new Date(this.ruleForm.receivableEndTime)
              ) {
                callback(new Error('开始时间不能大于等于结束时间'));
              } else {
                callback();
              }
            }
          }
        ],

        receivableEndTime: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              console.log(value);
              if (_.trim(value) === '') {
                callback(new Error('请选择汇票到期日'));
              } else if (
                new Date(value) <=
                new Date(
                  this.ruleForm.cpTime
                    ? this.ruleForm.cpTime
                    : '1970-01-01'
                )
              ) {
                callback(new Error('结束时间不能小于等于开始时间'));
              } else if (
                new Date(value).getTime() + 57600000 <
                new Date().getTime()
              ) {
                callback(new Error('结束时间不能早于当前时间'));
              } else {
                callback();
              }
            }
          }
        ]

      },
      rules7: {
        buyerId: [{ type: 'number',
          required: true,
          message: '请选择买方',
          trigger: 'blur' }],
        type: [{ type: 'string',
          required: true,
          message: '请选择类型',
          trigger: 'change' }],
        baseProductId: [{
          type: 'number',
          required: true,
          message: '请选择产品',
          trigger: 'blur'
        }],
        pmnum2: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请输入票面金额'));
              } else if (_.isNaN(Number(value))) {
                callback(new Error('票面金额必须为数字'));
              } else {
                callback();
              }
            }
          }
        ],
        cdrkname2: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请输入承兑人开户行'));
              } else {
                callback();
              }
            }
          }
        ],
        acceptorBankSwift2: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请输入承兑人开户行行号'));
              } else {
                callback();
              }
            }
          }
        ],
        cdrname2: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请输入承兑人全称'));
              } else {
                callback();
              }
            }
          }
        ],
        cprqc2: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请输入出票人全称'));
              } else {
                callback();
              }
            }
          }
        ],
        pjnum2: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请输入票据号码'));
              } else {
                callback();
              }
            }
          }
        ],
        cpTime2: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请选择单据日期'));
              } else if (
                new Date(value) >= new Date(this.ruleForm.receivableEndTime)
              ) {
                callback(new Error('开始时间不能大于等于结束时间'));
              } else {
                callback();
              }
            }
          }
        ],
        receivableEndTime2: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              console.log(value);
              if (_.trim(value) === '') {
                callback(new Error('请选择汇票到期日'));
              } else if (
                new Date(value) <=
                new Date(
                  this.ruleForm.cpTime2
                    ? this.ruleForm.cpTime2
                    : '1970-01-01'
                )
              ) {
                callback(new Error('结束时间不能小于等于开始时间'));
              } else if (
                new Date(value).getTime() + 57600000 <
                new Date().getTime()
              ) {
                callback(new Error('结束时间不能早于当前时间'));
              } else {
                callback();
              }
            }
          }
        ]
      },
      rules8: {
        buyerId: [{ type: 'number',
          required: true,
          message: '请选择买方',
          trigger: 'blur' }],
        type: [{ type: 'string',
          required: true,
          message: '请选择类型',
          trigger: 'change' }],
        baseProductId: [{
          type: 'number',
          required: true,
          message: '请选择产品',
          trigger: 'blur'
        }]
      },
      rules9: {
        buyerId: [{ type: 'number',
          required: true,
          message: '请选择买方',
          trigger: 'blur' }],
        baseProductId: [{
          type: 'number',
          required: true,
          message: '请选择产品',
          trigger: 'blur'
        }],
        contractNumber: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请输入贸易合同名称及编号'));
              } else {
                callback();
              }
            }
          }
        ]
      },
      rulesImport: {
        buyerId: [{ type: 'number',
          required: true,
          message: '请选择买方',
          trigger: 'blur' }],
        contractNumber: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请输入合同名称及合同编号'));
              } else {
                callback();
              }
            }
          }
        ],
        baseProductId: [{
          type: 'number',
          required: true,
          message: '请选择产品',
          trigger: 'blur'
        }]
      },
      voucherInfoId: '',
      voucher: []
    };
  },
  computed: {
    ...mapGetters({
      userInfo: types.GET_USER,
      ajaxBaseUrl: types.GET_AJAX_BASE_URL
    })
  },
  created () {
    this.billData();
    this.buyerNameData();
  },
  mounted () {
    this.getByNodeKeyPC({
      NodeKeys: 'AccountVoucherState,AccountVoucherAuthResult,voucher_type'
    });
    this.getProductList();
  },
  methods: {
    // 导入表格
    // 上传文件之前的钩子
    beforeUpload (file) {
      console.log('beforeUpload');
      console.log(file.type);
      console.log(file);
      const _this = this;
      const isText = file.type === 'application/vnd.ms-excel';
      const isTextComputer = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
      if (!isText && !isTextComputer) {
        this.setFailMessage({
          show: true,
          content: '请上传.xls或.xls格式的表格'
        });
        return false;
      }
      return true;
    },
    // 上传文件
    uploadFile (item) {
      console.log(item);
      const fileObj = item.file;
      console.log(`file1:${JSON.stringify(fileObj)}`);
      console.log(this.comId);
      // FormData 对象
      const form = new FormData();
      // 文件对象
      form.append('file', fileObj);
      form.append('comId', this.comId);
      console.log(`file:${JSON.stringify(form)}`);
      // let formTwo = JSON.stringify(form)
      api.postExcelList(
         {tokenId: localStorage.getItem('dl_tokenId_bl')},
         {file: fileObj}).then((res) => {
           if (res.rspcode == 1) {
             this.setSuccessMessage({
               show: true,
               content: res.rspdesc
             });
             this.billData();
           } else {
             this.setFailMessage({
               show: true,
               content: res.rspdesc
             });
           }
         }).catch((error) => {});
    },

    // 下载模板
    downExcel () {
      let url = window.location.href;
      console.log(window.location.href);
      if (url.indexOf('#') != -1) {
        url = url.split('#')[0];
      }
      const elink = document.createElement('a');
      elink.style.display = 'none';
      elink.target = '_blank';
      elink.href = `${url}api/loanform/blitem/blLoanAccountVoucherInfo/downloadExcelTemplate.ht`;
      document.body.appendChild(elink);
      elink.click();
      document.body.removeChild(elink);
    },
    ...mapActions({
      setFailMessage: types.SET_FAIL_MESSAGE,
      setSuccessMessage: types.SET_SUCCESS_MESSAGE
    }),
    // 点击类型里面任意值改变表单样式
    changeFrom () {
      this.isSubmit = false;
      this.isValidate = false;
      if (this.$refs.ruleForm2) {
        // this.$refs.ruleForm2.resetFields();
      } else if (this.$refs.ruleForm3) {
        this.$refs.ruleForm3.resetFields();
      } else if (this.$refs.ruleForm4) {
        this.$refs.ruleForm4.resetFields();
      } else if (this.$refs.ruleForm5) {
        this.$refs.ruleForm5.resetFields();
      } else if (this.$refs.ruleForm6) {
        this.$refs.ruleForm6.resetFields();
      } else if (this.$refs.ruleForm7) {
        this.$refs.ruleForm7.resetFields();
      } else if (this.$refs.ruleForm8) {
        this.$refs.ruleForm8.resetFields();
      }
      if (this.$refs.ruleForm9) {
        // this.$refs.ruleForm9.resetFields();
      }
      if (this.$refs.ruleForm10) {
        this.$refs.ruleForm10.resetFields();
      }

      if (this.ruleForm.type == 1) {
        this.dome1 = true;
        this.dome = true;
        this.dome2 = false;
        this.dome3 = false;
        this.dome5 = false;
        this.dome6 = false;
        this.dome7 = false;
      } else if (this.ruleForm.type == 2) {
        this.dome1 = false;
        this.dome = true;
        this.dome2 = true;
        this.dome3 = false;
        this.dome5 = false;
        this.dome6 = false;
        this.dome7 = false;
      } else if (this.ruleForm.type == 3) {
        this.dome1 = false;
        this.dome = true;
        this.dome2 = false;
        this.dome3 = true;
        this.dome5 = false;
        this.dome6 = false;
        this.dome7 = false;
      } else if (this.ruleForm.type == 4) {
        this.dome1 = false;
        this.dome = false;
        this.dome2 = false;
        this.dome3 = false;
        this.dome5 = false;
        this.dome6 = false;
        this.dome7 = false;
      } else if (this.ruleForm.type == 5) {
        this.dome1 = false;
        this.dome = true;
        this.dome2 = false;
        this.dome3 = false;
        this.dome5 = true;
        this.dome6 = false;
        this.dome7 = false;
      } else if (this.ruleForm.type == 6) {
        this.dome1 = false;
        this.dome = true;
        this.dome2 = false;
        this.dome3 = false;
        this.dome5 = false;
        this.dome6 = true;
        this.dome7 = false;
      } else if (this.ruleForm.type == 7) {
        this.dome1 = false;
        this.dome = true;
        this.dome2 = false;
        this.dome3 = false;
        this.dome5 = false;
        this.dome6 = false;
        this.dome7 = true;
      }
    },
    //
    rowClick (index, row) {
      this.$router.push({
        path: '/frontVoucherInfo_pj',
        query: {
          voucherInfoId: row.voucherInfoId,
          authState: this.authState,
          type: 1
        }
      });
    },
    selectapprove (item) {
      this.authState = item;
      this.pageCurrent = 1;
      this.billData();
    },
    selectstate (state) {
      this.state = state;
      this.pageCurrent = 1;
      this.billData();
    },

    // 状态选中事件
    handleClick (tab) {
      const state = tab.name;
      this.authState = tab.name == 5 ? '' : tab.name;
      this.pageCurrent = 1;
      this.billData();
    },
    // 编辑
    handleEdit (index, row) {
      this.isMasking = true;
      this.voucherInfoId = row.voucherInfoId;
      //          进来没有点击添加时，需要初始化上传组件
      if (this.uploader == undefined) {
        const _this = this;
        setTimeout(() => {
          _this.createWebUploader();
          _this.uploader.refresh();
        }, 1000);
      }

      api.getFrontVoucherInfoDetails({
        voucherInfoId: row.voucherInfoId,
        tokenId: localStorage.getItem('dl_tokenId_bl')
      }).then((res) => {
        console.log(`res.rspcode:${res.rspcode}`);
        if (res.rspcode == 1) {
          this.DialogInputBankInfo = true;
          const end = this.formTime(
              res.data.voucherInfo.accountsReceivableEndTime
            );
          const start = this.formTime(
              res.data.voucherInfo.accountsReceivableStartTime
            );
          this.sysFileIds = res.data.voucherInfo.sysFileIds
              ? JSON.parse(res.data.voucherInfo.sysFileIds.replace(/\'/g, '"'))
              : [];

          let typeData = {};
            // 订单
          if (res.data.voucherInfo.type == 1) {
            typeData = {
              djTime: start, // 开票日期
              contractNumber: res.data.voucherInfo.contractNumber, // 合同编号
              deliveryNo: res.data.voucherInfo.bizNo, // 订单号
              pm: res.data.order.goodsName, // 品名
              ggxh: res.data.order.spec, // 规格型号
              dw: res.data.order.unit, // 单位
              sl: res.data.order.num, // 数量
              dj: res.data.order.unitPrice, // 单价
              zj: res.data.order.totalPrice, // 总价
              ddnum: res.data.voucherInfo.accountsReceivableAmount // 发票金额
            };
          }
            // 送货单/入库单
          if (res.data.voucherInfo.type == 2) {
            typeData = {
              djTime2: start, // 开票日期
              contractNumber: res.data.voucherInfo.contractNumber, // 合同编号
              shrk: res.data.voucherInfo.bizNo, // 送货单号
              dd: res.data.order.orderNo,
              pm2: res.data.order.goodsName, // 品名
              ggxh2: res.data.order.spec, // 规格型号
              dw2: res.data.order.unit, // 单位
              sl2: res.data.order.num, // 数量
              dj2: res.data.order.unitPrice, // 单价
              zj2: res.data.order.totalPrice, // 总价
              shnum: res.data.voucherInfo.accountsReceivableAmount // 发票金额
            };
          }
            // 结算单
          if (res.data.voucherInfo.type == 3) {
            typeData = {
              djTime3: start, // 开票日期
              contractNumber: res.data.voucherInfo.contractNumber, // 合同编号
              jsnum: res.data.voucherInfo.bizNo, // 结算单号
              orderNo: res.data.order.receiptNo,  // 收货单号
              pm3: res.data.order.goodsName, // 品名
              ggxh3: res.data.order.spec, // 规格型号
              dw3: res.data.order.unit, // 单位
              sl3: res.data.order.num, // 数量
              dj3: res.data.order.unitPrice, // 单价
              zj3: res.data.order.totalPrice, // 总价
              jsdnum: res.data.voucherInfo.accountsReceivableAmount // 发票金额
            };
          }
            // 发票
          if (res.data.voucherInfo.type == 4) {
            typeData = {
              startTime: start, // 开票日期
              contractNumber: res.data.voucherInfo.contractNumber, // 合同编号
              lnvoiceNumber: res.data.voucherInfo.bizNo, // 发票号码
              ddh: res.data.order.orderNo, // 订单号
              receiptNo: res.data.order.deliveryNo, // 送货单号
              goodsName: res.data.order.goodsName, // 品名
              spec: res.data.order.spec, // 规格型号
              unit: res.data.order.unit, // 单位
              num: res.data.order.num, // 数量
              unitPrice: res.data.order.unitPrice, // 单价
              totalPrice: res.data.order.totalPrice, // 总价
              contractAmount: res.data.voucherInfo.accountsReceivableAmount, // 发票金额
              signDate: res.data.voucherInfo.signDate // 签署日期
            };
          }
            // 银承
          if (res.data.voucherInfo.type == 5) {
            typeData = {
              cpTime: start, // 出票日期
              receivableEndTime: end, // 汇票到期日
              pjnum: res.data.voucherInfo.bizNo, // 票据号码
              cprqc: res.data.bill.drawer, // 出票人全称
              cdrname: res.data.bill.acceptor, // 承兑人全称
              cdrkname: res.data.bill.acceptorBank, // 承兑人开户行
              acceptorBankSwift:res.data.bill.acceptorBankSwift,//承兑人开户行行号
              contractNumber: res.data.voucherInfo.contractNumber, // 合同编号
              pmnum: res.data.voucherInfo.accountsReceivableAmount // 票面金额
            };
          }
            // 商承
          if (res.data.voucherInfo.type == 6) {
            typeData = {
              contractNumber: res.data.voucherInfo.contractNumber, // 合同编号
              cpTime2: start, // 出票日期
              receivableEndTime2: end, // 汇票到期日
              pjnum2: res.data.voucherInfo.bizNo, // 票据号码
              cprqc2: res.data.bill.drawer, // 出票人全称
              cdrname2: res.data.bill.acceptor, // 承兑人全称
              cdrkname2: res.data.bill.acceptorBank, // 承兑人开户行
              acceptorBankSwift2:res.data.bill.acceptorBankSwift,//承兑人开户行行号
              pmnum2: res.data.voucherInfo.accountsReceivableAmount // 票面金额
            };
          }
          const _sysFileIds = res.data.voucherInfo.sysFileIds
              ? JSON.parse(res.data.voucherInfo.sysFileIds.replace(/\'/g, '"'))
              : [];
          this.ruleForm = {
            type: res.data.voucherInfo.type, // 凭证类型
            buyerId: res.data.voucherInfo.buyerId, // 买方（核心企业）名称
            buyerNameList: [],
            ...typeData,
            sysFileIds: _sysFileIds,
            netAmount: res.data.voucherInfo.netAmount, // 应收账款净额
            baseProductId: res.data.voucherInfo.baseProductId
          };
        }
        this.buyerNameData();
      })
        .catch((error) => {});
    },
    // 删除
    removeData (row) {
      const _this = this;
      _this
        .$confirm('是否确定删除该条凭证?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          api.delVoucherInfo({
            tokenId: localStorage.getItem('dl_tokenId_bl'),
            voucherInfoIds: row.voucherInfoId
          }).then((res) => {
            if (res.rspcode == 1) {
              this.setSuccessMessage({
                show: true,
                content: res.rspdesc
              });
              this.billData();
            } else {
              this.setFailMessage({
                show: true,
                content: res.rspdesc
              });
            }
          }).catch((error) => {});
        }).catch(() => {
          _this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    },

    //      列表分页方法
    changePage (currentPage) {
      this.pageCurrent = currentPage;
      this.billData();
    },

    // 初始化列表数据
    billData () {
      api.getFrontVoucherInfoList({
        tokenId: localStorage.getItem('dl_tokenId_bl'),
        frontApplyId: 0,
        type: 'list',
        pageNum: this.pageCurrent,
        pageSize: this.pageSize,
        state: this.state,
        authState: this.authState,
        bizNo:this.search.bizNo
      }).then((res) => {
        if (res.rspcode == 1) {
          this.voucherInfoList = res.data.voucherInfoList;
          this.voucher = res.data.voucherInfoList;
          this.voucherInfoCount = res.data.voucherInfoCount;
          this.voucherInfoList.forEach((t, i) => {
            this.voucherInfoList[i].receivableEndTime = this.formTime(
              t.receivableEndTime
            );
          });
        }
      }).catch((error) => {});
    },
    // 初始化买方数据
    buyerNameData () {
      api.addFrontVoucherInfoPage({
        tokenId: localStorage.getItem('dl_tokenId_bl'),
        frontApplyId: 0
      }).then((res) => {
        if (res.rspcode == 1) {
          this.ruleForm.buyerNameList = res.data;
        }
      }).catch((error) => {});
    },

    showPreviewImage (fileId, isImage) {
      const src = `${
        this.ajaxBaseUrl
      }/mobile/crmCustomerAttachInfoController/getFile.ht?fileId=${fileId}&tokenId=${
        this.userInfo.token
      }`;
      if (isImage) {
        this.filePreview = {
          show: true,
          src
        };
      } else {
        window.open(`${location.origin}${src}`);
      }
    },

    hidePreviewImage () {
      this.filePreview.show = false;
    },

    //      删除附件
    deleteUploadedFile (file) {
      const fileIndex = _.findIndex(
        this.sysFileIds,
        item => item.fileId === file.fileId
      );
      this.sysFileIds.splice(fileIndex, 1);
    },

    uploadBeforeSend (obj, data) {
      (data.tokenId = localStorage.getItem('dl_tokenId_bl')),
        (this.isShowProgress = true);
    },
    uploadProgress (file, percent) {
      const _this = this;
      _this.progress = percent * 100;
    },
    uploadSuccess (file, res) {
      const _self = this;
      const arr = _.split(res, ':');

      this.sysFileIds.push({
        fileId: Number(arr[0].replace('sysFile=', '')),
        fileName: file.name,
        uploaderId: file.id // 上传文件id
      });
      const newFile = {
        fileId: Number(arr[0].replace('sysFile=', '')),
        fileName: file.name,
        uploaderId: file.id // 上传文件id
      };
      this.progress = 0;
      this.isShowProgress = false;
    },
    uploadError (file, reason) {
      if (reason === 'http') {
        this.setFailMessage({
          show: true,
          content: '上传出错！请更新浏览器到最新版本或使用谷歌浏览器上传！'
        });
      }
      this.uploader.removeFile(file, true);
      this.progress = 0;
      this.isShowProgress = false;
    },
    uploadValidata (type) {
      switch (type) {
        case 'F_DUPLICATE': // 是否重复
          this.setFailMessage({
            show: true,
            content: '该文件您已经上传过了，请不要重复上传！'
          });
          break;
        case 'Q_TYPE_DENIED': // 文件类型是否满足
          this.setFailMessage({
            show: true,
            content:
              '请上传后缀为.jpg，.gif，.bmp，.gif，.doc，.rar，.zip，.7z的文件'
          });
          break;
        case 'Q_EXCEED_SIZE_LIMIT': // 文件大小是否超出
          this.setFailMessage({
            show: true,
            content: '请上传大小不超过10M的文件'
          });
          break;
      }
    },

    createWebUploader () {
      this.uploader = Webuploader.create({
        auto: true, // 自动上传
        swf: './static/Uploader.swf',
        server: `${
          this.ajaxBaseUrl
        }/mobile/crmCustomerAttachInfoController/saveFile.ht`,
        pick: {
          id: '.picker',
          multiple: true
        },
        chunked: true,
        duplicate: true, // 去重
        fileSizeLimit: 1024 * 1024 * 10,
        accept: {
          title: '*',
          extensions: 'gif,jpg,jpeg,png',
          mimeTypes:
            'image/*'
        }
      });
      this.uploader.on('uploadBeforeSend', this.uploadBeforeSend);
      this.uploader.on('uploadProgress', this.uploadProgress);
      this.uploader.on('uploadSuccess', this.uploadSuccess);
      this.uploader.on('uploadError', this.uploadError);
      this.uploader.on('error', this.uploadValidata);
    },

    // 添加数据
    bounced () {
      this.DialogInputBankInfo = true;
      this.isMasking = true;
      this.voucherInfoId = '';
      this.emptyData();
      this.buyerNameData();
      this.sysFileIds = [];
      document.documentElement.style.overflowY = 'hidden';
      //        去除在添加存留的校验提示
      this.$refs.ruleForm && this.$refs.ruleForm.resetFields();
      //        第一次进来页面没有对应节点，在点击添加的时候再初始化插件
      this.ruleForm.type = '4';
      if (this.uploader == undefined) {
        const _this = this;
        setTimeout(() => {
          _this.createWebUploader();
          _this.uploader.refresh();
        }, 500);
      }
    },
    // 关闭
    close () {
      this.isMasking = false;
      this.DialogInputBankInfo = false;
      this.ruleForm.receivableEndTime = '';
    },

    // 清空数据数据
    emptyData () {
      this.ruleForm = {
        buyerId: '', // 买方（核心企业）名称
        type: '', // 凭证类型
        baseProductId: '',
        buyerNameList: [],
        contractNumber: '', // 合同编号
        lnvoiceNumber: '', // 发票号码
        deliveryNo: '', // 订单号
        receiptNo: '', // 送货单号
        // goodsName: '', // 品名
        // spec: '', // 规格型号
        // num: '', // 单位
        // unit: '', // 数量
        // unitPrice: '', // 单价
        // totalPrice: '', // 总价
        // contractAmount: '', // 发票金额
        // drawer: '', // 出票人全称
        // acceptor: '', // 承兑人全称
        // acceptorBank: '', // 承兑人开户行名称
        // receivableAmount: '', // 应收账款金额
        // advanceChargeAmount: '', // 预付款金额
        // alreadyPaidAmount: '', // 已付款金额
        // commissionAmount: '', // 佣金及转让金额
        receivableEndTime: '', // 汇票到期日
        receivableEndTime2: '', // 汇票到期日
        startTime: '', // 开票日期
        djTime: '', // 订单中的单据日期
        htbh: '', // 订单中的合同编号
        ddh: '', // 订单中的订单号
        pm: '', // 订单中的品名
        ggxh: '', // 订单中的规格型号
        dw: '', // 订单中的单位
        sl: '', // 订单中的数量
        dj: '', // 订单中的单价
        zj: '', // 订单中的总价
        ddnum: '', // 订单总额
        djTime2: '', // 送货单/入库单的单据日期
        htbh2: '', // 送货单/入库单的合同编号
        pm2: '', // 送货单/入库单的品名
        shrk: '', // 送货/入库单号
        dd: '', // 送货单/入库单的订单号
        ggxh2: '', // 送货单/入库单的规格型号
        dw2: '', // 送货单/入库单的单位
        sl2: '', // 送货单/入库单的数量
        dj2: '', // 送货单/入库单的单价
        zj2: '', // 送货单/入库单的总价
        shnum: '', // 送货单/入库单的送货单金额
        djTime3: '', // 结算单的单据日期
        htbh3: '', // 结算单的合同编号
        pm3: '', // 结算单的品名
        jsnum: '', // 结算单号
        orderNo: '', // 结算单的收货单号
        ggxh3: '', // 结算单的规格型号
        dw3: '', // 结算单的单位
        sl3: '', // 结算单的数量
        dj3: '', // 结算单的单价
        zj3: '', // 结算单的总价
        jsdnum: '', // 结算单金额
        cpTime: '', // 银承的出票日期
        pjnum: '', // 银承的票据号码
        cprqc: '', // 银承的出票人全称
        cdrname: '', // 银承的承兑人全称
        cdrkname: '', // 银承的承兑人开户行
        pmnum: '', // 银承的票面金额
        cpTime2: '', // 银承的出票日期
        pjnum2: '', // 银承的票据号码
        cprqc2: '', // 银承的出票人全称
        cdrname2: '', // 银承的承兑人全称
        cdrkname2: '', // 银承的承兑人开户行
        pmnum2: '' // 银承的票面金额
      };
    },
    // 提交数据
    submitForm (r) {
      const ruleFormType = this.ruleForm.type;
      /* if (this.sysFileIds.length == 0) {
        this.setFailMessage({
          show: true,
          content: '请添加附件'
        });
        return;
      } */
      console.log('fuck');

      const codeSysfiled = encodeURIComponent(JSON.stringify(this.sysFileIds));
      const sameType = {
        tokenId: localStorage.getItem('dl_tokenId_bl'),
        voucherInfoId: this.voucherInfoId || 0, // 凭证id(主键)
        frontApplyId: 0, // 项目id
        type: ruleFormType, // 类型
        buyerId: this.ruleForm.buyerId, // 买方
        sysFileIds: codeSysfiled, // 附件
        netAmount: this.ruleForm.netAmount, // 应收账款净额
        baseProductId: this.ruleForm.baseProductId // 产品id
      };
      let params = {};
      this.$refs.ruleForm9.validate((valid) => {
        if (valid) {
          this.isValidate = true;
        }
      });

      if (ruleFormType == '2') {
        this.$refs.ruleForm4.validate((valid) => {
          if (valid && this.isValidate) {
            this.isSubmit = true;
            // 送货单/入库单
            params = {
              ...sameType,
              receivableStartTime: this.ruleForm.djTime2, // 开票日期
              receivableEndTime: '', // 结束日期
              contractNumber: this.ruleForm.contractNumber, // 合同编号
              bizNo: this.ruleForm.shrk, // 送货单号
              orderNo: this.ruleForm.dd,
              receiptNo: '',  // 收货单号
              deliveryNo: '', // 送货单号
              goodsName: this.ruleForm.pm2, // 品名
              spec: this.ruleForm.ggxh2, // 规格型号
              unit: this.ruleForm.dw2, // 单位
              num: this.ruleForm.sl2, // 数量
              unitPrice: this.ruleForm.dj2, // 单价
              totalPrice: this.ruleForm.zj2, // 总价
              receivableAmount: this.ruleForm.shnum // 发票金额
            };
          }
        });
      } else if (ruleFormType == '1') {
        this.$refs.ruleForm3.validate((valid) => {
          if (valid && this.isValidate) {
            this.isSubmit = true;
            // 订单
            params = {
              ...sameType,
              receivableStartTime: this.ruleForm.djTime, // 开票日期
              receivableEndTime: '', // 结束日期
              contractNumber: this.ruleForm.contractNumber, // 合同编号
              bizNo: this.ruleForm.deliveryNo, // 订单号
              orderNo: '',
              receiptNo: '',  // 收货单号
              deliveryNo: '', // 送货单号
              goodsName: this.ruleForm.pm, // 品名
              spec: this.ruleForm.ggxh, // 规格型号
              unit: this.ruleForm.dw, // 单位
              num: this.ruleForm.sl, // 数量
              unitPrice: this.ruleForm.dj, // 单价
              totalPrice: this.ruleForm.zj, // 总价
              receivableAmount: this.ruleForm.ddnum // 发票金额
            };
          }
        });
      } else if (ruleFormType == '3') {
        this.$refs.ruleForm5.validate((valid) => {
          if (valid && this.isValidate) {
            this.isSubmit = true;
            // 结算单
            params = {
              ...sameType,
              receivableStartTime: this.ruleForm.djTime3, // 开票日期
              receivableEndTime: '', // 结束日期
              contractNumber: this.ruleForm.contractNumber, // 合同编号
              bizNo: this.ruleForm.jsnum, // 结算单号
              orderNo: '',
              receiptNo: this.ruleForm.orderNo,  // 收货单号
              deliveryNo: '', // 送货单号
              goodsName: this.ruleForm.pm3, // 品名
              spec: this.ruleForm.ggxh3, // 规格型号
              unit: this.ruleForm.dw3, // 单位
              num: this.ruleForm.sl3, // 数量
              unitPrice: this.ruleForm.dj3, // 单价
              totalPrice: this.ruleForm.zj3, // 总价
              receivableAmount: this.ruleForm.jsdnum // 发票金额
            };
          }
        });
      } else if (ruleFormType == '4') {
        this.$refs.ruleForm2.validate((valid) => {
          if (valid && this.isValidate) {
            this.isSubmit = true;
            // 发票
            params = {
              ...sameType,
              receivableStartTime: this.ruleForm.startTime, // 开票日期
              receivableEndTime: '', // 结束日期
              contractNumber: this.ruleForm.contractNumber, // 合同编号
              bizNo: this.ruleForm.lnvoiceNumber, // 发票号码
              orderNo: this.ruleForm.ddh, // 订单号
              receiptNo: '',  // 收货单号
              deliveryNo: this.ruleForm.receiptNo, // 送货单号
              goodsName: this.ruleForm.goodsName, // 品名
              spec: this.ruleForm.spec, // 规格型号
              unit: this.ruleForm.unit, // 单位
              num: this.ruleForm.num, // 数量
              unitPrice: this.ruleForm.unitPrice, // 单价
              totalPrice: this.ruleForm.totalPrice, // 总价
              receivableAmount: this.ruleForm.contractAmount, // 发票金额
              signDate: this.ruleForm.signDate // 签署日期
            };
          }
        });
      } else if (ruleFormType == '5') {
        this.$refs.ruleForm6.validate((valid) => {
          if (valid && this.isValidate) {
            this.isSubmit = true;
            // 银承
            params = {
              ...sameType,
              receivableStartTime: this.ruleForm.cpTime, // 出票日期
              receivableEndTime: this.ruleForm.receivableEndTime, // 汇票到期日
              bizNo: this.ruleForm.pjnum, // 票据号码
              drawer: this.ruleForm.cprqc, // 出票人全称
              acceptor: this.ruleForm.cdrname, // 承兑人全称
              acceptorBank: this.ruleForm.cdrkname, // 承兑人开户行
              acceptorBankSwift:this.ruleForm.acceptorBankSwift,//承兑人开户行行号
              receivableAmount: this.ruleForm.pmnum, // 票面金额
              contractNumber:this.ruleForm.contractNumber//合同编号
            };
            console.log(params);
          }
        });
      } else if (ruleFormType == '6') {
        this.$refs.ruleForm7.validate((valid) => {
          if (valid && this.isValidate) {
            this.isSubmit = true;
            // 商承
            params = {
              ...sameType,
              receivableStartTime: this.ruleForm.cpTime2, // 出票日期
              receivableEndTime: this.ruleForm.receivableEndTime2, // 汇票到期日
              bizNo: this.ruleForm.pjnum2, // 票据号码
              drawer: this.ruleForm.cprqc2, // 出票人全称
              acceptor: this.ruleForm.cdrname2, // 承兑人全称
              acceptorBank: this.ruleForm.cdrkname2, // 承兑人开户行
              acceptorBankSwift:this.ruleForm.acceptorBankSwift2,//承兑人开户行行号
              contractNumber:this.ruleForm.contractNumber,//合同编号
              receivableAmount: this.ruleForm.pmnum2 // 票面金额
            };
          }
        });
      } else if (ruleFormType == '7') {
        this.$refs.ruleForm8.validate((valid) => {
          if (valid && this.isValidate) {
            this.isSubmit = true;
            // 其他凭证
            params = {
              ...sameType,
              contractNumber:this.ruleForm.contractNumber//合同编号
            };
          }
        });
      }
      if (this.isSubmit) {
        api.saveFrontVoucherInfo(params).then((res) => {
          if (res.rspcode == 1) {
            this.setSuccessMessage({
              show: true,
              content: res.rspdesc
            });
            this.isMasking = false;
            this.DialogInputBankInfo = false;
            this.billData();
          } else {
            this.setFailMessage({
              show: true,
              content: res.rspdesc
            });
          }
        })
        .catch((error) => {});
      }
    },
    // 重置数据
    resetForm () {
      this.emptyData();
    },

    //    时间戳转换
    formTime (value) {
      const time = new Date(value);
      const year = time.getFullYear();
      let month = time.getMonth() + 1;
      let day = time.getDate();
      let h = time.getHours();
      let mm = time.getMinutes();
      if (month <= 9) {
        month = `0${month}`;
      }
      if (day <= 9) {
        day = `0${day}`;
      }
      if (h <= 9) {
        h = `0${h}`;
      }
      if (mm <= 9) {
        mm = `0${mm}`;
      }
      return `${year}-${month}-${day}`;
    },

    //      获取数据字典
    getByNodeKeyPC (param) {
      api.getByNodeKeyPC(param).then((res) => {
        this.stateList = this.stateList.concat(res[0]);
        this.approveList = this.approveList.concat(res[1]);
        this.typeList = this.typeList.concat(res[2]);
      });
    },
    // 获取产品列表
    getProductList () {
      productsApi.getProductListData({
        tokenId: localStorage.getItem('dl_tokenId_bl')
      }).then((res) => {
        if (Number(res.rspcode) === 1) {
          this.productList = res.data.proList;
        }
      });
    },
    dateChange (e, type) {
      if (e) {
	        const date = e.replace(/(\s*)/g, '').replace(/年/, '-').replace(/月/, '-').replace(/日/, '');
        this.ruleForm[`${type}`] = date;
	        if (type == 'receivableStartTime') {
	        	this.ruleForm.receivableStartTime = date;
	        } else if (type == 'receivableEndTime') {
		        this.ruleForm.receivableEndTime = date;
	        }
      }
    },
    // 导入功能开始----------------------------------------
    importData (type) {
      if (type == 'ocr') {
        this.emptyData();
        this.buyerNameData();
        this.dialogImportVisibleOcr = true;
        this.importUrl = `${this.ajaxBaseUrl}/mobile/crmCustomerAttachInfoController/saveFile.ht`;
      } else {
        this.dialogImportVisibleExcel = true;
        this.importUrl = `${this.ajaxBaseUrl}/loanform/blitem/blLoanAccountVoucherInfo/importExcel.ht`;
      }
      this.excelData = {
        tokenId: localStorage.getItem('dl_tokenId_bl')
      };
      this.ocrData = {
        tokenId: localStorage.getItem('dl_tokenId_bl')
      };
        this.importFlag = 1;
        this.fileList = [];
        this.uploadTip = '点击上传';
        this.processing = false;
     },
    handlePreview (file) {
      // 可以通过 file.response 拿到服务端返回数据
    },
    handleRemove (file, fileList) {
      // 文件移除
      for (var i in this.fileList) {
          for (var k in this.fileList[i]) {
                if (this.fileList[i][k] == file.uid) {
                    delete this.fileList[i];
                break;
              }
          }
      }     
      this.sysFileIds = []; 
    },
     beforeUploadImportExcel (file) {
      // 上传前配置
        const excelfileExtend = '.xls,.xlsx';// 设置文件格式
        const fileExtend = file.name.substring(file.name.lastIndexOf('.')).toLowerCase();
        if (excelfileExtend.indexOf(fileExtend) <= -1) {
        this.setFailMessage({
          show: true,
          content: '文件格式错误'
        });
           return false;
        }
        this.uploadTip = '正在处理中...';
        this.processing = true;
     },
     beforeUploadImportOcr (file) {
      // 上传前配置
        const excelfileExtend = '.zip';// 设置文件格式
        const fileExtend = file.name.substring(file.name.lastIndexOf('.')).toLowerCase();
        if (excelfileExtend.indexOf(fileExtend) <= -1) {
        this.setFailMessage({
          show: true,
          content: '文件格式错误'
        });
           return false;
        }
        this.uploadTip = '正在处理中...';
        this.processing = true;
     },
  // 上传错误
     uploadFailImport (err, file, fileList) {
        this.uploadTip = '点击上传';
        this.processing = false;
      this.setFailMessage({
        show: true,
        content: err
      });
     },
   // 上传成功
     uploadSuccessImport (response, file, fileList) {
        this.uploadTip = '点击上传';
        this.processing = false;
        if (response.code === 0) {
          this.importFlag = 3;
            this.dialogImportVisibleExcel = false;
        this.setSuccessMessage({
          show: true,
          content: '导入成功'
        });
          this.billData();
        } else {
       // this.importFlag = 2
        this.setFailMessage({
          show: true,
          content: response.msg
        });
        };
      this.fileList = [];
     },
     uploadSuccessImportOcr (response, file, fileList) {
      this.fileList = [];
      this.fileList[0] = file;
      this.sysFileIds = [];
      this.uploadTip = '点击上传';
      this.processing = false;
      const arr = _.split(response, ':');
      this.sysFileIds.push({
        fileId: Number(arr[0].replace('sysFile=', '')),
        fileName: file.name,
        uploaderId: file.id // 上传文件id
      });
     },
   // 下载模板
    downTemplate () {
      let url = window.location.href;
      console.log(window.location.href);
      if (url.indexOf('#') != -1) {
        url = url.split('#')[0];
      }
      const elink = document.createElement('a');
      elink.style.display = 'none';
      elink.target = '_blank';
      elink.href = `${url}api/loanform/blitem/blLoanAccountVoucherInfo/downloadExcelTemplate.ht`;
      document.body.appendChild(elink);
      elink.click();
      document.body.removeChild(elink);
    },
    // ocr导入
    importOcr () {
      this.$refs.ruleFormImport.validate((valid) => {
        if (valid) {
          if (this.sysFileIds.length == 0) {
            this.setFailMessage({
              show: true,
              content: '请先上传导入文件'
            });
            return;
          }
          const loadingInstance = Loading.service({ fullscreen: true, text: '导入中...' });
          const codeSysfiled = this.sysFileIds ? encodeURIComponent(JSON.stringify(this.sysFileIds)) : '';
          this.ruleForm.netAmount = this.ruleForm.netAmount || '';
          api.importOcr({
            buyerId: this.ruleForm.buyerId,
            contractNumber: this.ruleForm.contractNumber,
            netAmount: this.ruleForm.netAmount,
            baseProductId: this.ruleForm.baseProductId,
            tokenId: localStorage.getItem('dl_tokenId_bl'),
            signDate: this.ruleForm.signDate,
            sysFileIds: codeSysfiled
          }).then((res) => {
            if (res.code === 0) {
              loadingInstance.close();
              this.dialogImportVisibleOcr = false;
              this.billData();
              this.setSuccessMessage({
                show: true,
                content: res.msg
              });
            } else {
              loadingInstance.close();
              this.setFailMessage({
                show: true,
                content: res.msg
              });
            }
          });
        }
      });
    }
    // 导入功能结束----------------------------------------
  }
};
</script>

<style lang="scss">
//覆盖饿了么UI样式
.upload-demo{
  display: inline-block;
}
#myBill {
  .el-tabs__item {
    box-sizing: border-box;
    padding: 0 30px;
    font-size: 14px;
    color: #34495e;
    /*font-family: 'FZLanTingHei-DB-GBK';*/
    &:first-child {
      color: #00c0ff;
    }
  }

  .el-tabs__header {
    border-bottom: none;
    margin: 0;
  }

  .is-active {
    color: #35c4f9;
  }

  .el-tabs__active-bar {
    background-color: #35c4f9;
  }
  .el-tabs__active-bar {
    bottom: 3px;
    height: 0.1em;
  }
}
.myBill {
  position: relative;
  background: #fff;
  left: 20px;
  margin-top: 20px;
  padding-top: 20px;
  .bullTop {
    .bullBox {
      /*width: 500px;*/
    }
    .loan-lists {
      padding-left: 20px;
      box-sizing: border-box;
      /*position: relative;*/
      margin-bottom: 10px;
      width: 100%;
/*       .el-select {
        width: 20%;
      } */
      .stateList {
        margin-left: 30px;
      }
    }
  }
  .bullState {
    padding: 10px 0 0px 20px;
    border-bottom: 2px solid #ccc;
    color: #34495e;
    font-size: 16px;
    .cur {
      border-bottom: 2px solid #00c0ff;
      /*padding-bottom: 5px;*/
      color: #00c0ff;
    }

    li {
      display: inline-block;
      height: 30px;
      margin: 0 20px;
      text-align: center;
      box-sizing: border-box;
      cursor: pointer;
      /*padding-bottom:15px;*/
      box-sizing: border-box;
      span {
        /*color: #34495e;*/
      }
      /*选中状态*/
      /*&:first-of-type{*/
      /*!*border-bottom: 2px solid #00c0ff;*!*/
      /*color: #00c0ff;*/
      /*}*/
    }
  }
  /*选中状态*/
  .active {
    padding-bottom: 5px;
    color: #EB662B;
  }
  .btnPost{
    position: absolute;
    right: 20px;
    top: 40px;
    z-index: 1;
  }
  .btnAdd {
    font-size: 14px;
    /*position: absolute;*/
    /*right: 0;*/
  }
.el-button--primary:hover {
    color: #fff;
    background-color: #EB782B;
    border-color: #EB782B;
}
  .btn {
    width: 40px;
    line-height: 24px;
    padding: 0;

    /*background: #000;*/
  }
  .btn-disable {
    background-color: #99a3a7 !important;
    color: #fff;
    border: none;
  }

  .operation {
    width: 32px;
  }

  .step3_pagination {
    text-align: center;
    padding: 20px 0;
    /*选中状态*/
    .active {
      border-bottom: 0;
    }
  }
  /*弹窗样式*/
  .financing-dialog {
    .financing-dialog-form-body {
      // overflow: hidden;
    }
    .step3Close {
      color: #ff8b38;
      text-align: right;
      margin-bottom: 20px;
      cursor: pointer;
    }
    .el-form-item {
      width: 50%;
      float: left;
    }
    .el-form-item2 {
      width: 100%;
      float: left;
    }     
    .el-form-item__label {
      /*color: #ff8b38;*/
    }
    .el-dialog__body {
      padding: 50px 20px 20px;
    }
    .el-dialog__footer {
      width: 100%;
      display: flex;
      justify-content: center;
      .el-button {
        width: 100px;
        margin-bottom: 30px;
      }
      .el-button:first-child {
        background: #EB662B;
        color: $white;
        border-color: #EB662B;
      }
    }
    .el-input,
    .el-select {
      width: 100%;
      float: left;
      .el-input__inner,
      .el-input {
        width: 100%;
      }
    } 
    .file-list__item-preview,
    .file-list__select-file {
      width: 48%;
    }
  }
}
.el-table__body-wrapper {
	margin-top:1px!important;
}
// .file-list__item-list {
  

//   li:nth-child(3) {
//     float: left;
//         margin-top: 40%;
//     margin-left: -48%;
    
//   }
//   li:nth-child(4) {
//     float: right;
//     margin-top: 10.5%;
//   }
//  li:nth-child(1){
//     margin-top: 65px;
//     margin-left: -100%; 
//   }
//   li:nth-child(2) {
//     margin-top: 5px;
//     margin-right: 0px;
//   }
// }

// .pinker{
//    padding: 10px 20px 15px;
//     text-align: center;
//     box-sizing: border-box;
//         display: block;
// }
// #pick  {
//     background-image:url('../../../static/images/addlogo.png');
//     background-repeat:no-repeat;
//     background-size:100% 100%;
//     -moz-background-size:100% 100%;
//   } 
</style>



// WEBPACK FOOTER //
// MyBill.vue?172f6a90